import { type FC } from "react";

import "./SelectComponent.scss";

import { type Team } from "@entities";
import clsx from "clsx";

interface SelectComponentProps {
  itemsList: Team[] | undefined;
  chosenList: string[];
  title: string;
  isAdd?: boolean;
}

export const SelectComponentTeams: FC<SelectComponentProps> = (props) => {
  const { itemsList, chosenList, title, isAdd } = props;
  const chosenSet = new Set(chosenList);
  const chosen = Array.from(chosenSet);
  if (!itemsList) return <div>-</div>;
  return (
    <div className="select-container">
      <label style={{ fontSize: "0.8rem", paddingLeft: "2rem" }}>{title}</label>
      <div className="list-items-container">
        {chosen.length
          ? <>
            {itemsList
              .filter((item) => chosen.includes(item.id))
              .slice(0, 3)
              .map((item) => (
                <div
                  className={clsx("list-item", {
                    chosen: chosen?.includes(item.id),
                  })}
                  key={item.id}
                >
                  {item.name}
                </div>
              ))}
            {chosen.length > 3 && <div className="list-item more">{chosen.length - 3}+</div>}
          </>
          : isAdd
            ? "קרתה תקלה"
            : "-"}
      </div>
    </div>
  );
};
